module.exports = __webpack_public_path__ + "static/media/02.3184ee22.png";